import '../charts/text/section_separator.js.coffee'

Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.DashboardChartsView extends Backbone.View
  template: JST["backbone/templates/monitoring/dashboard_charts"]

  events:
    'click #graph-list a.addChart': 'addChart'
    'click #graph-list a.customChart': 'showCustomChartCreator'
    'click .refresh-dashboard': '_refresh'
    'click #sort_asc': 'sortAsc'
    'click #sort_desc': 'sortDesc'
    'click .sharing-session-button': 'onClickShare'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @eventList = @options.eventList
    @tagsByClientCode = @options.tagsByClientCode || []
    @taxonomiesCodes = @options.taxonomiesCodes || []
    @renderIsPending = true
    @totalCount = @options.totalCount
    @uniqueUsersCount = @options.uniqueUsersCount
    @wordsRankingCalculator ||= new Monitoring.Views.Charts.WordsRankingCalculator({
      searchQuery: @searchQuery,
      facets: @facets
    })
    Highcharts.setOptions({
      global:
        useUTC: false
    })
    @charts = []
    @multipleTimesCharts = ["HierarchyNavigationChartView", "HierarchyNavigationBarsChartView", "HistogramByTaxonomyView", "HierarchyNavigationHeatmapChartView"]
    @sessionSharingData = @options.sessionSharingData
    @sessionSharingView = new Monitoring.Views.Dashboards.SessionSharingView(@sessionSharingData)
    @socialContentsPreview = new Monitoring.Views.SocialContentsPreview({submodesPermissions: @options.submodesPermissions})
    @socialContentsPreview.bind('masonry', @masonry)

  render: ->
    @$el.html(@template({
      totalCount: @totalCount
      uniqueUsersCount: @uniqueUsersCount
      sessionSharingData: @sessionSharingData
    }))
    @renderCustomChartCreator()
    @renderSessionSharing()
    @$el.find('#preview_container').html(@socialContentsPreview.render().el)
    @

  renderCustomChartCreator: ->
    @dimensionsList = ['gender', 'labels', 'hashtags', 'tags', 'topics', 'languages', 'locations', 'mentions', 'moderators', 'sentiment', 'type', 'sub_type', 'status', 'country', 'filtered_tags', 'filtered_labels']
    custom_fields = (key.replace('custom_', '') for key of @facets.custom_facets)
    @customChartCreator = new Monitoring.Views.Charts.CustomCreator(custom_fields, @dimensionsList, undefined, @taxonomiesCodes)
    @customChartCreator.bind('addChart', @addCustomChart)
    @customChartCreator.render()
    @$el.append(@customChartCreator.el)

  renderSessionSharing: ->
    @renderSessionSharingButtonView()
    @renderSessionSharingView()
    @listenTo(@sessionSharingView, 'sharedSession:changed', (sessionSharingData) =>
      @sessionSharingData = sessionSharingData
      @renderSessionSharingButtonView()
    )

  lazyRender: ->
    if @renderIsPending
      @renderIsPending = false

      @chartContainer = @$el.find('#chart-container')

      charts = @searchQuery.get('charts')
      for chart in charts
        @createChart(chart)
      @updateChartList()
    @masonry()

    return this

  renderSessionSharingButtonView: ->
    @sessionSharingButtonView = new Monitoring.Views.SessionSharingButtonView(@sessionSharingData)
    @$el.find('.session-sharing-button-container').html(@sessionSharingButtonView.render().$el)
    @listenTo(@sessionSharingButtonView, 'editSharingOptions:clicked', =>
      @sessionSharingView.onClickShare()
    )
    @listenTo(@sessionSharingButtonView, 'stopSharing:clicked', =>
      @sessionSharingView.onClickStopSharing()
    )

  renderSessionSharingView: ->
    @$el.find('.session-sharing-container').html(@sessionSharingView.render().$el)

  onClickShare: ->
    if @searchQuery.get('analysisMode')
      @openNewSession()
    else
      @sessionSharingView.onClickShare()

  masonry: =>
    callback = () =>
      @$el.find('#chart-container').masonry(
        columnWidth: '.grid-sizer',
        gutter: '.gutter-sizer',
        itemSelector: '.item'
      )
      resizeCharts()

    setTimeout callback, 100

  destroy: ->
    @$el.html('')
    @socialContentsPreview.destroy()
    @remove()

  addPageTitle: (page_title) ->
    @$el.find('#chart-container').prepend(page_title)

  add_dom_to_front: (dom, delimiter) ->
    if(@$el.find(delimiter).length <=0)
      @$el.find('#chart-container').prepend(dom)

  createChart: (settings) ->
    chartOptions = @getChartOptions(settings)
    chartClass = Monitoring.Views.Charts[settings.class]
    try
      chart = new chartClass(chartOptions)
      chart.appendChart(@chartContainer)
      chart.bind('chartsChange', @chartsChange)
      chart.bind('removeChart', @removeChart)
      chart.bind('masonry', @masonry)
      chart.bind('insertNote', @insertNote)
      chart.bind('sortAsc', @sortAsc)
      chart.bind('sortDesc', @sortDesc)
      chart.bind('closeNote', @closeNote)
      chart.bind('showSocialContentsPreview', @showSocialContentsPreview)
    catch error
      chart.displayError() if chart?
      console.log error
    @charts.push(chart) if chart?
    chart

  getChartOptions: (settings) ->
    {
      searchQuery: @searchQuery,
      facets: @facets,
      eventList: @eventList,
      settings: settings
      tagsByClientCode: @tagsByClientCode
      calculator: @wordsRankingCalculator
      container: @
      showBenchmarkOption: false,
      readonly: false
    }

  removeChart: (chartToRemove) =>
    @charts.splice(@charts.indexOf(chartToRemove), 1)
    @eventAggregator.trigger('monitoring:chart:remove', chartToRemove.getGAName())
    @chartsChange()

  chartsChange: () =>
    newCharts = ( chart.settings() for chart in @charts )
    @searchQuery.changeState('charts', newCharts)
    @updateChartList()
    @masonry()

  updateChartList: () ->
    activeCharts = (chart.class for chart in @chartToHideInList())
    activeCharts = activeCharts.filter (c) -> c != 'SectionSeparator'

    ul = @$el.find('#graph-list')
    ul.find('li').removeClass('hidden')

    for chart in activeCharts
      ul.find("[data-class=#{chart}]").parent().addClass('hidden')

  addChart: (event) =>
    settings = { class: $(event.target).data('class') }
    chart = @createChart(settings)
    @eventAggregator.trigger('monitoring:chart:add', chart.getGAName()) if chart?
    @$el.find('#chart-container').masonry('reloadItems')
    @chartsChange()

  addCustomChart: (settings) =>
    chart = @createChart(settings)
    @eventAggregator.trigger('monitoring:chart:add', chart.getGAName()) if chart?
    @$el.find('#chart-container').masonry('reloadItems')
    @chartsChange()

  showCustomChartCreator: () =>
    @customChartCreator.show()

  sortAsc:(event) =>
    operation = (index) -> index - 1
    condition = (index) -> index == 0
    sort = ($chart, $chartToChange) -> $chartToChange.insertAfter($chart)

    @_sort(event.currentTarget.offsetParent, operation, condition, sort)

  sortDesc:(event) =>
    operation = (index) -> index + 1
    condition = (index) => index + 1 == @charts.length
    sort = ($chart, $chartToChange) -> $chart.insertAfter($chartToChange)

    @_sort(event.currentTarget.offsetParent, operation, condition, sort)

  _refresh: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  _sort:(event, operation, condition, sort) =>
    chart = _.find(@charts, (chart) -> chart if chart.$el[0] == event)
    index = @charts.indexOf(chart)

    return if (condition(index))

    indexToChange = operation(index)
    chartToChange = @charts[indexToChange]

    # Reorder charts list
    @charts.splice(index, 1)
    @charts.splice(indexToChange, 0, chart)
    # Reorder charts DOM
    sort(chart.$el, chartToChange.$el)
    @$el.find('#chart-container').masonry('reloadItems')
    @chartsChange()

  chartToHideInList: =>
    @searchQuery.get('charts').filter (x) => @multipleTimesCharts.indexOf(x.class) == -1

  showSocialContentsPreview: (searchQuery) =>
    @socialContentsPreview.showWith(searchQuery)

  openNewSession: ->
    query = @searchQuery.deepCopy()
    session_name = query.get('name')
    name = "Post anlysis comments"
    @eventAggregator.trigger('cloneDashboardAndShareSession', {query, name})
